import { Hidden } from "@material-ui/core";
import { useMemo } from "react";
import DonutChart from "src/components/ScoringChart/DonutChart";
import VectorMetric from "src/components/utils/VectorMetric";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { useTokenAnalysisSelector } from "src/context/tokenAnalysisContext";

const getOption = () => ({
  chart: {
    height: 240,
  },
  legend: {
    align: "middle",
    verticalAlign: "middle",
    layout: "vertical",
  },
});

const getXSOption = () => ({
  chart: {
    height: 300,
  },
  legend: {
    align: "center",
    verticalAlign: "top",
    layout: "horizontal",
  },
});

export default function Statistic() {
  const statistic = useTokenAnalysisSelector((state) => state.stats);

  const realRange = useMemo(() => {
    if (statistic?.ranges) {
      const ranges = statistic?.ranges;
      const level1 = ranges["Sick"][1] - ranges["Sick"][0];
      const level2 = ranges["Fine"][1] - ranges["Fine"][0];
      const level3 = ranges["Good"][1] - ranges["Good"][0];
      const level4 = ranges["Great"][1] - ranges["Great"][0];
      const level5 = ranges["Fantastic"][1] - ranges["Fantastic"][0];
      return [level1, level2, level3, level4, level5];
    }
    return [0, 0, 0, 0, 0];
  }, [statistic]);

  const percentages = useMemo(() => {
    if (statistic?.percentages) {
      const data = Object.keys(statistic.percentages).map((element) => {
        return {
          name: element,
          y: statistic.percentages[element],
        };
      });
      return [
        {
          name: "statistic",
          data: data,
        },
      ];
    }
    return [
      {
        name: undefined,
        data: [],
      },
    ];
  }, [statistic]);

  return (
    <PaperWrapper title="Statistic" paperProps={{ style: { height: 330 } }}>
      <Hidden smDown>
        <DonutChart series={percentages} option={getOption()} />
      </Hidden>
      <Hidden mdUp>
        <DonutChart series={percentages} option={getXSOption()} />
      </Hidden>
      <VectorMetric
        ranges={realRange}
        categories={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
        style={{ paddingTop: "0.5rem" }}
      />
    </PaperWrapper>
  );
}
